export default __webpack_public_path__ + "static/media/성령의 불 기도.15d24b1f.jpg";